// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TdsBreakDownMain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7019607843);
  backdrop-filter: blur(3px);
  display: flex;
  justify-content: center;
  align-items: center;
}
.TdsBreakDownMain .TdsBreakDownSub {
  width: 35rem;
  height: 30rem;
  background: var(--Foreground);
  border-radius: 0.625rem;
  padding: 1rem;
  position: relative;
}
.TdsBreakDownMain .TdsBreakDownSub .TdsHeader {
  display: flex;
}
.TdsBreakDownMain .TdsBreakDownSub .TdsHeader h3 {
  flex: 1 1;
  color: var(--AccentColor);
}
.TdsBreakDownMain .TdsBreakDownSub .TdsHeader svg:hover {
  transform: rotate(90deg);
  transition: all 0.3s ease;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet {
  margin-top: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount {
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.625rem;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .RefDetails {
  display: flex;
  padding: 0.625rem;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .RefDetails .ReferenceDetails {
  flex: 1 1;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .RefDetails .ReferenceDetails .Reference {
  color: #9B9B9B;
  font-size: 1rem;
  font-weight: 600;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .RefDetails .ReferenceDetails .ReferenceNumber {
  color: Var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
  padding-left: 0.625rem;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .RefDetails .DateDetails .Date {
  color: #9B9B9B;
  font-size: 1rem;
  font-weight: 600;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .RefDetails .DateDetails .DateNumber {
  color: Var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
  padding-left: 0.625rem;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .TaxDetails {
  border-top: 0.0625rem solid var(--Stroke);
  padding: 0.625rem;
  border-bottom: 0.0625rem solid var(--Stroke);
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .TaxDetails p {
  display: flex;
  padding: 0.25rem;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .TaxDetails p .Taxable {
  flex: 1 1;
  color: #9B9B9B;
  font-size: 0.8rem;
  font-weight: 300;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .TaxDetails p .TaxableAmt {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--TextColor);
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .AmtToPay {
  padding: 0.5rem;
  display: flex;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .AmtToPay .AmountPay {
  color: var(--TextColor);
  flex: 1 1;
  font-size: 1rem;
  font-weight: 600;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .SplitAmount .AmtToPay .Amount {
  color: var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .PaymentType {
  display: flex;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .PaymentType .PaymentGateway {
  width: 16.5rem;
  height: 10rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.625rem;
  padding: 0.625rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 1.25rem;
  cursor: pointer;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .PaymentType .PaymentGateway .WalletPayAmt {
  color: var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .PaymentType .PaymentGateway .PayViaWallet {
  color: var(--AccentColor);
  font-size: 1rem;
  font-weight: 700;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .PaymentType .PayWallet {
  width: 16.5rem;
  height: 10rem;
  margin-left: 0.5rem;
  border: 0.0625rem solid var(--Stroke);
  border-radius: 0.625rem;
  padding: 0.625rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  flex-direction: column;
  gap: 1.25rem;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .PaymentType .PayWallet .WalletPayAmt {
  color: var(--TextColor);
  font-size: 1rem;
  font-weight: 600;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentMet .PaymentType .PayWallet .PayViaWallet {
  color: var(--AccentColor);
  font-size: 1rem;
  font-weight: 700;
}
.TdsBreakDownMain .TdsBreakDownSub .PaymentLoading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.062745098);
  backdrop-filter: blur(3px);
}`, "",{"version":3,"sources":["webpack://./src/Components/BeginVerification/Modal/TdsBreakDownModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,6CAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;AACJ;AAAI;EACE,aAAA;AAEN;AADM;EACE,SAAA;EAEA,yBAAA;AAER;AAAM;EACE,wBAAA;EACA,yBAAA;AAER;AAEI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAAN;AACM;EACE,qCAAA;EACA,uBAAA;AACR;AAAQ;EACE,aAAA;EACA,iBAAA;AAEV;AADU;EACE,SAAA;AAGZ;AAFY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAId;AADY;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAGd;AACY;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AACd;AAEY;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAAd;AAIQ;EACE,yCAAA;EACA,iBAAA;EACA,4CAAA;AAFV;AAGU;EACE,aAAA;EACA,gBAAA;AADZ;AAEY;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAAd;AAEY;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;AAAd;AAIQ;EACE,eAAA;EACA,aAAA;AAFV;AAGU;EACE,uBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AADZ;AAGU;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AADZ;AAKM;EACE,aAAA;AAHR;AAIQ;EACE,cAAA;EACA,aAAA;EACA,qCAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;AAFV;AAGU;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AADZ;AAGU;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AADZ;AAIQ;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EAEA,mBAAA;EACA,sBAAA;EACA,YAAA;AAHV;AAIU;EACE,uBAAA;EACA,eAAA;EACA,gBAAA;AAFZ;AAIU;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;AAFZ;AAOI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,0BAAA;AALN","sourcesContent":[".TdsBreakDownMain {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000000b3;\n  backdrop-filter: blur(3px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  // z-index: 1;\n  .TdsBreakDownSub {\n    width: 35rem;\n    height: 30rem;\n    background: var(--Foreground);\n    border-radius: 0.625rem;\n    padding: 1rem;  \n    position: relative;  \n    .TdsHeader {\n      display: flex;\n      h3 {\n        flex: 1;\n        // text-align: center;\n        color: var(--AccentColor);\n      }\n      svg:hover{\n        transform: rotate(90deg);\n        transition: all 0.3s ease;\n      }\n      \n    }\n    .PaymentMet {\n      margin-top: 1.25rem;\n      display: flex;\n      flex-direction: column;\n      gap: 1.25rem;\n      .SplitAmount {\n        border: 0.0625rem solid var(--Stroke);\n        border-radius: 0.625rem;\n        .RefDetails {\n          display: flex;          \n          padding: 0.625rem;\n          .ReferenceDetails {\n            flex: 1;\n            .Reference {\n              color: #9B9B9B;\n              font-size: 1rem;\n              font-weight: 600;\n            }\n\n            .ReferenceNumber {\n              color: Var(--TextColor);\n              font-size: 1rem;\n              font-weight: 600;\n              padding-left: 0.625rem;\n            }\n          }\n          .DateDetails {\n            .Date {\n              color: #9B9B9B;\n              font-size: 1rem;\n              font-weight: 600;\n            }\n\n            .DateNumber {\n              color: Var(--TextColor);\n              font-size: 1rem;\n              font-weight: 600;\n              padding-left: 0.625rem;\n            }\n          }\n        }\n        .TaxDetails {\n          border-top: 0.0625rem solid var(--Stroke);\n          padding: 0.625rem;\n          border-bottom: 0.0625rem solid var(--Stroke);\n          p {\n            display: flex;\n            padding: 0.25rem;\n            .Taxable {\n              flex: 1;\n              color: #9B9B9B;\n              font-size: 0.8rem;\n              font-weight: 300;\n            }\n            .TaxableAmt {\n              font-size: 0.8rem;\n              font-weight: 600;\n              color: var(--TextColor);\n            }\n          }\n        }\n        .AmtToPay {\n          padding: 0.5rem;\n          display: flex;\n          .AmountPay {\n            color: var(--TextColor);\n            flex: 1;\n            font-size: 1rem;\n            font-weight: 600;\n          }\n          .Amount {\n            color: var(--TextColor);\n            font-size: 1rem;\n            font-weight: 600;\n          }\n        }\n      }\n      .PaymentType {\n        display: flex;\n        .PaymentGateway {\n          width: 16.5rem;\n          height: 10rem;\n          border: 0.0625rem solid var(--Stroke);\n          border-radius: 0.625rem;\n          padding: 0.625rem;\n          display: flex;\n          align-items: center;\n          flex-direction: column;\n          gap: 1.25rem;\n          cursor: pointer;\n          .WalletPayAmt {\n            color: var(--TextColor);\n            font-size: 1rem;\n            font-weight: 600;\n          }\n          .PayViaWallet {\n            color: var(--AccentColor);\n            font-size: 1rem;\n            font-weight: 700;\n          }\n        }\n        .PayWallet {\n          width: 16.5rem;\n          height: 10rem;\n          margin-left: 0.5rem;\n          border: 0.0625rem solid var(--Stroke);\n          border-radius: 0.625rem;\n          padding: 0.625rem;\n          display: flex;\n          cursor: pointer;\n          // justify-content: center;\n          align-items: center;\n          flex-direction: column;\n          gap: 1.25rem;\n          .WalletPayAmt {\n            color: var(--TextColor);\n            font-size: 1rem;\n            font-weight: 600;\n          }\n          .PayViaWallet {\n            color: var(--AccentColor);\n            font-size: 1rem;\n            font-weight: 700;\n          }\n        }\n      }\n    }\n    .PaymentLoading{\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      background: #00000010;\n      backdrop-filter: blur(3px);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
